module.exports = __webpack_public_path__ + "static/media/mmf_pausenanimation_small_001.6bc1f2ca.png";